<div class="row">
  <div class="col">
    <p>I have reviewed and agree with the following:</p>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="over18"
        [formControl]="getFormControl('Over18')"
      />
      <small>
        <label class="form-check-label" for="over18">
          I am 18 years of age or older
        </label>
      </small>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="privacyPolicy"
        [formControl]="getFormControl('PrivacyPolicy')"
      />
      <small>
        <label class="form-check-label" for="privacyPolicy">
          I have read the
          <a
            [href]="isConsumerLoanApplication ? loanTermsURL : creditTermsURL"
            target="_blank"
          >
            Privacy Policy, Terms of Use, Electronic Communications Consent, and
            Credit Authorization.
          </a>
        </label>
      </small>
    </div>

    <div class="form-check">
      <input
        class="form-check-input"
        type="checkbox"
        value=""
        id="communicationConsent"
        [formControl]="getFormControl('CommunicationConsent')"
      />
      <small>
        <label
          *ngIf="isConsumerLoanApplication; else otherStatement"
          class="form-check-label eagle-label"
          for="communicationConsent"
        >
          {{ loanConsentCopy }}
        </label>
        <ng-template #otherStatement>
          <label class="form-check-label sims-label" for="communicationConsent">
            {{ creditConsentCopy }}
          </label>
        </ng-template>
      </small>
    </div>

    <ngb-alert class="mt-3" [dismissible]="false" type="light">
      <h4 class="text-dark">Your privacy is our #1 priority.</h4>
      <p>
        We use 128-bit SSL protection and strict levels of security and
        encryption standards to keep your data safe.
      </p>
    </ngb-alert>
  </div>
</div>
